import { faKey, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@restart/ui/esm/Button";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Label } from "reactstrap";
import {
  changePassword,
  clearChangePasswordMessage,
  clearForgotPasswordMessage,
  forgotPassword,
} from "../redux/rootActions";
import { TranslationComponentProps } from "../types/translationComponentProps";

interface IProps extends TranslationComponentProps {
  openLogin: () => void;
  closeForgotPassword: () => void;
  forgotPasswordToken: string;
  setForgotPasswordToken: (string) => void;
}

const ForgotPassword: React.FC<IProps> = (props: IProps) => {
  const [showDoNotMatchPassError, setShowDoNotMatchPassError] = useState(false);
  const dispatch = useDispatch();
  const { forgotPasswordMsg, changePasswordMsg } = useSelector(
    (state: RootStateOrAny) => state.Auth,
  );

  const handleValidSubmit = (event, values) => {
    if (!props.forgotPasswordToken) {
      dispatch(forgotPassword(values.email));
    } else {
      setShowDoNotMatchPassError(false);
      if (values.password !== values.repeatedPassword) {
        setShowDoNotMatchPassError(true);
      } else {
        dispatch(changePassword(values.password, props.forgotPasswordToken));
      }
    }
  };

  const backToLogin = () => {
    props.setForgotPasswordToken("");
    props.closeForgotPassword();
    props.openLogin();
    dispatch(clearForgotPasswordMessage());
    dispatch(clearChangePasswordMessage());
  };

  return (
    <div className="login">
      <AvForm onValidSubmit={handleValidSubmit}>
        <div className="d-flex justify-content-center pt-2 pl-3 w-100 login-header">
          <Label>{props.t("FORGOT_PASSWORD.title")}</Label>
        </div>

        {!props.forgotPasswordToken ? (
          <div className="d-inline-flex w-100 align-items-center login-row">
            <Button className="login-input-btn" disabled>
              <FontAwesomeIcon icon={faUserAlt} />
            </Button>
            <AvInput
              className="login-input"
              name="email"
              placeholder={props.t("LOGIN.email")}
              type="email"
            />
          </div>
        ) : (
          <>
            <div className="d-inline-flex w-100 align-items-center login-row">
              <Button className="login-input-btn" disabled>
                <FontAwesomeIcon icon={faKey} />
              </Button>
              <AvInput
                className="login-input"
                name="password"
                placeholder={props.t("REGISTRATION.password")}
                type="password"
              />
            </div>
            <div className="d-inline-flex w-100 align-items-center login-row">
              <Button className="login-input-btn" disabled>
                <FontAwesomeIcon icon={faKey} />
              </Button>
              <AvInput
                className="login-input"
                name="repeatedPassword"
                placeholder={props.t("REGISTRATION.retype_password")}
                type="password"
              />
            </div>
          </>
        )}
        <div className="d-inline-flex w-100 justify-content-center align-items-center login-submit mt-2">
          <Button className="login-button" type="submit">
            {props.t("FORGOT_PASSWORD.submit")}
          </Button>
        </div>
        {forgotPasswordMsg && (
          <div className="d-flex justify-content-center pt-1 pb-2">
            {forgotPasswordMsg === "success" ? (
              <span className="success_message">
                {props.t("FORGOT_PASSWORD.check_email")}
              </span>
            ) : (
              <span className="text-danger">
                {props.t("FORGOT_PASSWORD.unknown_email")}
              </span>
            )}
          </div>
        )}
        {(showDoNotMatchPassError || changePasswordMsg) && (
          <div className="d-flex justify-content-center pt-1 pb-2">
            {changePasswordMsg === "success" ? (
              <span className="success_message">
                {props.t("FORGOT_PASSWORD.password_changed")}
              </span>
            ) : (
              <span className="text-danger">
                {changePasswordMsg === "error"
                  ? props.t("FORGOT_PASSWORD.change_password_error")
                  : props.t("REGISTRATION.do_not_match")}
              </span>
            )}
          </div>
        )}
        <div className="d-flex justify-content-center pt-1 pb-2">
          <span className="text-secondary">{props.t("LOGIN.back_to")}</span>
          <span className="forgot_pass_login" onClick={() => backToLogin()}>
            {props.t("LOGIN.login")}
          </span>
        </div>
      </AvForm>
    </div>
  );
};

export default withTranslation()(ForgotPassword);
